var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWandMagic = function SvgWandMagic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#wand-magic_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.685 2.63.272 8.933a.58.58 0 0 0 0 .835l1.697 1.668a.603.603 0 0 0 .849 0L9.23 5.132zM11.728 2.676a.58.58 0 0 0 0-.834L10.03.173a.607.607 0 0 0-.849 0L7.533 1.795l2.545 2.503zM9.6 9.64H9v-.59a.595.595 0 0 0-.6-.59c-.332 0-.6.264-.6.59v.59h-.6c-.332 0-.6.264-.6.59s.268.59.6.59h.6v.59c0 .326.268.59.6.59s.6-.264.6-.59v-.59h.6c.332 0 .6-.264.6-.59a.595.595 0 0 0-.6-.59M.6 4.92h.6v.59c0 .326.268.59.6.59s.6-.264.6-.59v-.59H3c.332 0 .6-.264.6-.59a.595.595 0 0 0-.6-.59h-.6v-.59a.595.595 0 0 0-.6-.59c-.332 0-.6.264-.6.59v.59H.6c-.332 0-.6.264-.6.59s.268.59.6.59M10.2 6.69H9v1.18h1.2zM6.6.2H5.4v1.18h1.2zM4.8 1.38H3.6v1.18h1.2zM3 .2H1.8v1.18H3zM12 4.92h-1.2V6.1H12zM12 7.87h-1.2v1.18H12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wand-magic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgWandMagic;